import { area } from './area';
import { comun } from './comun';
import { contacto } from './contacto';
import { demo } from './demo';
import { legal } from './legal';
import { marketing } from './marketing';
import { meta } from './meta';
import type { Mensajes } from '../tipos';

/**
 * English dictionary.
 *
 * The `: Mensajes` annotation is the whole point: it makes TypeScript compare
 * this object against the Spanish one and **fail the build** if a key is
 * missing or has the wrong shape. Do not replace it with an inferred type.
 */
export const en: Mensajes = {
  area,
  comun,
  contacto,
  demo,
  legal,
  marketing,
  meta,
};
